import * as gateway from 'sfx-web-contract';
import { IFeedbackMessageResponse } from '../../../interfaces/feedback.interface';
import { IStreamData } from '../../../interfaces';

export const decodeFeedbackResponse = (response: IStreamData<Uint8Array>): IFeedbackMessageResponse => {
    const {
        Accepted: isAccepted,
        Reason: reason,
    } = gateway.FeedbackResponse.decode(response.payload);

    return { isAccepted, reason };
};
